/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MedicationRefillAnalysis
 */
export interface MedicationRefillAnalysis {
    /**
     * 
     * @type {string}
     * @memberof MedicationRefillAnalysis
     */
    medication_name: string;
    /**
     * 
     * @type {string}
     * @memberof MedicationRefillAnalysis
     */
    analysis: string;
    /**
     * 
     * @type {boolean}
     * @memberof MedicationRefillAnalysis
     */
    allow_refill: boolean;
}

/**
 * Check if a given object implements the MedicationRefillAnalysis interface.
 */
export function instanceOfMedicationRefillAnalysis(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "medication_name" in value;
    isInstance = isInstance && "analysis" in value;
    isInstance = isInstance && "allow_refill" in value;

    return isInstance;
}

export function MedicationRefillAnalysisFromJSON(json: any): MedicationRefillAnalysis {
    return MedicationRefillAnalysisFromJSONTyped(json, false);
}

export function MedicationRefillAnalysisFromJSONTyped(json: any, ignoreDiscriminator: boolean): MedicationRefillAnalysis {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'medication_name': json['medication_name'],
        'analysis': json['analysis'],
        'allow_refill': json['allow_refill'],
    };
}

export function MedicationRefillAnalysisToJSON(value?: MedicationRefillAnalysis | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'medication_name': value.medication_name,
        'analysis': value.analysis,
        'allow_refill': value.allow_refill,
    };
}

